import PropTypes from 'prop-types'
import {Fragment} from 'react'


// Gives a long email address soft break opportunities before the "@" (and before any "+" tag in the
// local part), so when the household layout is tight it wraps at those natural boundaries rather
// than at an arbitrary character or not at all. Renders unchanged when there is room.
export const breakableEmail = email => {
  if (!email)
    return email

  const pieces = email.split(/(?=[+@])/)

  if (pieces.length === 1)
    return email

  return pieces.map((piece, index) => (
    <Fragment key={index}>
      {index > 0 && <wbr />}
      {piece}
    </Fragment>
  ))
}

const hasSecondMember = props => Boolean(
  props.second_first_name || props.second_last_name || props.second_email
)

const isHousehold = props => props.record_type === 'household' || hasSecondMember(props)

const AcceptedClientRow = props => (
  <tr>
    {props.showHouseholdColumns && <td>{isHousehold(props) ? 'Household' : 'Individual'}</td>}
    <td>{props.first_name}</td>
    <td>{props.last_name}</td>
    {/* The three-column individual layout has room for whole emails, so it is left as it was. */}
    <td className='email'>{props.showHouseholdColumns ? breakableEmail(props.email) : props.email}</td>
    {props.showHouseholdColumns && <td>{isHousehold(props) ? props.second_first_name : ''}</td>}
    {props.showHouseholdColumns && <td>{isHousehold(props) ? props.second_last_name : ''}</td>}
    {props.showHouseholdColumns && <td className='email'>{isHousehold(props) ? breakableEmail(props.second_email) : ''}</td>}
  </tr>
)

AcceptedClientRow.propTypes = {
  email: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  record_type: PropTypes.string,
  second_email: PropTypes.string,
  second_first_name: PropTypes.string,
  second_last_name: PropTypes.string,
  showHouseholdColumns: PropTypes.bool
}

export default AcceptedClientRow
